import React from 'react';
import { LIBRARY_CRITERIA } from './salesData';
export function LibrarySection() {
  return <section id="biblioteca" className="bg-charcoal py-12 text-white sm:py-16" data-id="element-118" data-mp="23dbsd2uwhrdu">
      <div className="mx-auto max-w-md px-5 text-center sm:max-w-2xl" data-id="element-119" data-mp="2hcl4nrfzk1cj">
        <h2 className="font-display text-[1.5rem] font-extrabold leading-[1.12] tracking-tight sm:text-[2.1rem]" data-id="element-120" data-mp="2hbs63dr6ki5h">
          No necesitás fabricar 200 jabones.
          <span className="mt-1.5 block font-accent text-[1.15rem] font-medium tracking-normal text-champagne sm:text-[1.5rem]" data-id="element-121" data-mp="1pmgqiaitkajr">
            Necesitás 200 posibilidades para elegir.
          </span>
        </h2>

        <p className="mx-auto mt-4 max-w-[42ch] font-sans text-[0.88rem] leading-relaxed text-white/70" data-id="element-122" data-mp="1yeipe4d8pirx">
          Las 200 fórmulas funcionan como una biblioteca de consulta: entrás, elegís qué querés
          fabricar y lo hacés.
        </p>

        <ul className="mt-6 flex flex-wrap justify-center gap-1.5" data-id="element-123" data-mp="15v20nwukzucx">
          {LIBRARY_CRITERIA.map(c => <li key={c} className="rounded-full bg-white/[0.08] px-3 py-1.5 font-sans text-[0.76rem] font-medium text-white/85" data-id="element-124" data-mp="xh4n3djnc6ov">
              {c}
            </li>)}
        </ul>
      </div>
    </section>;
}